import StyledTopicTag from './styles';

interface TopicTagProps {
  text: string;
  color: string;
  density: 'panel' | 'page';
}

// Each org picks its own color per compliance topic (project settings) --
// that choice is meaningful to them (severity, category, ...), so the topic
// name always renders as a tag in that color, never as plain text.
export default function TopicTag(props: TopicTagProps) {
  const { text, color, density } = props;
  return (
    <StyledTopicTag color={color} density={density} title={text}>
      {text}
    </StyledTopicTag>
  );
}
